/* import __COLOCATED_TEMPLATE__ from './customize-reply-buttons.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { QUICK_REPLY_ID } from 'embercom/lib/operator/resolution-bot/constants';
import type AiAgentQuickRepliesService from 'embercom/services/ai-agent-quick-replies-service';

interface SelectItem {
  value: string;
  text: string;
  fullText: string;
}

interface PreviewConfiguration {
  locale: string;
}

interface Args {
  previewConfiguration: PreviewConfiguration;
  quickReplies: $TSFixMe;
  body: $TSFixMe;
}

interface QuickReplyButton {
  propName: string;
  selectedItem: string;
  items: Array<SelectItem>;
  description: string;
  tooltipText: string;
}

export default class CustomizeReplyButtons extends Component<Args> {
  @service declare intercomEventService: $TSFixMe;
  @service declare aiAgentQuickRepliesService: AiAgentQuickRepliesService;

  get customizableQuickReplies(): Array<QuickReplyButton> {
    return [
      this._quickReplyButton(QUICK_REPLY_ID.ALL_DONE, 'allDoneLabel'),
      this._quickReplyButton(QUICK_REPLY_ID.WAIT_FOR_THE_TEAM, 'waitForTheTeamLabel'),
    ];
  }

  get resolutionButtonQuickReplies(): QuickReplyButton {
    return this._quickReplyButton(QUICK_REPLY_ID.ALL_DONE, 'allDoneLabel');
  }

  get escalationButtonQuickReplies(): QuickReplyButton {
    return this._quickReplyButton(QUICK_REPLY_ID.WAIT_FOR_THE_TEAM, 'waitForTheTeamLabel');
  }

  @action
  setQuickReplyLabel(labelProp: string, labelValue: string): void {
    this.args.quickReplies[labelProp] = labelValue;
  }

  @action
  trackAiAgentQuickReplySettings(): void {
    let quickReplyChoices = this.args.quickReplies.getProperties(
      'allDoneLabel',
      'waitForTheTeamLabel',
    );

    this.intercomEventService.trackAnalyticsEvent({
      action: 'updated',
      section: 'operator',
      place: 'operator_settings',
      object: 'ai_agent_quick_reply_settings',
      ...quickReplyChoices,
    });
  }

  private _quickReplyButton(buttonId: string, labelProp: string): QuickReplyButton {
    let { locale } = this.args.previewConfiguration;
    let quickReply = this.aiAgentQuickRepliesService.getById(buttonId);

    return {
      propName: labelProp,
      selectedItem: this.args.quickReplies[labelProp],
      items: this.aiAgentQuickRepliesService.getSelectItems(buttonId, locale) || [],
      description: quickReply?.description ?? '',
      tooltipText: quickReply?.tooltipText ?? '',
    };
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Settings::CustomizeReplyButtons': typeof CustomizeReplyButtons;
    'ai-agent/settings/customize-reply-buttons': typeof CustomizeReplyButtons;
  }
}
